import {UploadSchemaState} from "./UploadSchemaContext";

export enum UploadSchemaActionType {
  UPLOAD_SCHEMA,
  UPLOAD_SCHEMA_PROGRESS,
  SCHEMA_UPLOADED,
  UPLOAD_SCHEMA_ERROR,
  GET_SCHEMA,
  SCHEMA_LOADED,
  GET_SCHEMA_ERROR,
  SAVE_SCHEMA,
  SAVE_SCHEMA_ERROR,
  UPDATE_SCHEMA,
  UPDATE_SCHEMA_ERROR,
  CHANGE_SCHEMA,
  REMOVE_ERROR,
  ACTIVATE_SCHEMA_ERROR,
  SET_SCHEMA_ID,
  SET_ID_VALIDATION_STATE,
  TOGGLE_REQUEST_IN_PROGRESS
}

type Action = {
  type: UploadSchemaActionType;
  payload: any
}

export default (state: UploadSchemaState, action: Action) => {
  switch (action.type) {
    case UploadSchemaActionType.TOGGLE_REQUEST_IN_PROGRESS:
      return {
        ...state,
        isRequestRunning: action.payload.isRequestRunning
      };
    case UploadSchemaActionType.UPLOAD_SCHEMA:
      return {
        ...state,
        file: action.payload.file,
        schema: action.payload.schema,
        schemaYaml: action.payload.schemaYaml,
        error: action.payload.error
      };
    case UploadSchemaActionType.UPLOAD_SCHEMA_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
        uploading: action.payload.uploading,
        loading: action.payload.loading
      };
    case UploadSchemaActionType.SCHEMA_UPLOADED:
      return {
        ...state,
        file: action.payload.file,
        uploading: action.payload.uploading,
        loading: action.payload.loading
      };
    case UploadSchemaActionType.GET_SCHEMA:
      return {
        ...state,
        loading: action.payload.loading
      };
    case UploadSchemaActionType.SCHEMA_LOADED:
      return {
        ...state,
        uploadedSchema: action.payload.uploadedSchema,
        schema: action.payload.schema,
        schemaYaml: action.payload.schemaYaml,
        schemaId: action.payload.schemaId,
        loading: action.payload.loading,
        permissions: action.payload.permissions
      };
    case UploadSchemaActionType.SAVE_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema,
        schemaYaml: action.payload.schemaYaml,
        schemaId: action.payload.schemaId,
        isBound: action.payload.isBound,
        saved: action.payload.saved,
        permissions: action.payload.permissions
      };
    case UploadSchemaActionType.UPDATE_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema,
        schemaYaml: action.payload.schemaYaml,
        isBound: action.payload.isBound,
        saved: action.payload.saved,
        permissions: action.payload.permissions
      };
    case UploadSchemaActionType.CHANGE_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema
      };
    case UploadSchemaActionType.REMOVE_ERROR:
      return {
        ...state,
        error: null
      };
    case UploadSchemaActionType.SET_SCHEMA_ID:
      return {
        ...state,
        schemaId: action.payload.schemaId
      };
    case UploadSchemaActionType.SET_ID_VALIDATION_STATE:
      return {
        ...state,
        idValidationState: action.payload.idValidationState
      };
    case UploadSchemaActionType.UPLOAD_SCHEMA_ERROR:
    case UploadSchemaActionType.UPDATE_SCHEMA_ERROR:
    case UploadSchemaActionType.ACTIVATE_SCHEMA_ERROR:
    case UploadSchemaActionType.SAVE_SCHEMA_ERROR:
    case UploadSchemaActionType.GET_SCHEMA_ERROR:
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
}
